import React from 'react';
import ButtonGeneral from '../general/buttons/buttonGeneral';
import { Grid, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LoadingButtonGeneral from '../general/buttons/loadingButtonGeneral';

type Props = {
    disableAdd?: boolean | false;
    enabledAddLoading?: boolean | false;
    disabledLoadingButton?: boolean;
    loadingButtonLoading?: boolean;
    loadingPositionButtonLoading?: 'center' | 'end' | 'start' | undefined;
    onClickBack: () => void;
    onClickButtonLoading?: any;
    onClickSave?: any;
    startIconButtonLoading?: JSX.Element | string;
    title: string;
    titleButtonLoading?: string;
    saveTitle?: string;
    saveIcon?: JSX.Element;
    additionalActionButton?: boolean;
    onClickAdditionalActionButton?: () => void;
    additionalActionIcon?: JSX.Element;
    additionalActionTitle?: string;
};

const FormView = ({
    title,
    onClickSave,
    onClickBack,
    disableAdd,
    enabledAddLoading,
    startIconButtonLoading,
    onClickButtonLoading,
    titleButtonLoading,
    loadingButtonLoading,
    loadingPositionButtonLoading,
    disabledLoadingButton,
    saveTitle = 'Guardar',
    saveIcon = <SaveIcon />,
    additionalActionButton,
    onClickAdditionalActionButton,
    additionalActionIcon,
    additionalActionTitle,
}: Props) => {
    return (
        <Grid mx={5}>
            <Typography
                color="primary"
                component="h3"
                sx={{ flexGrow: 1, fontSize: { lg: 24, md: 22, xs: 20 } }}
            >
                {title}
            </Typography>
            <hr color="#9F9E9EFF" />
            <Grid container sx={{ textAlign: 'right', mt: 2 }}>
                <Grid item xs={12} md={12} lg={12}>
                    {additionalActionButton && (
                        <ButtonGeneral
                            onClick={onClickAdditionalActionButton}
                            startIcon={additionalActionIcon}
                            title={additionalActionTitle || ''}
                            sx={{ mr: 1 }}
                        />
                    )}
                    {enabledAddLoading === true && (
                        <LoadingButtonGeneral
                            startIcon={startIconButtonLoading || ''}
                            onClick={onClickButtonLoading}
                            title={titleButtonLoading || ''}
                            loading={loadingButtonLoading}
                            loadingPosition={loadingPositionButtonLoading}
                            disabled={disabledLoadingButton}
                            sx={{ mr: 1 }}
                        />
                    )}
                    {disableAdd !== true && (
                        <ButtonGeneral
                            onClick={onClickSave}
                            startIcon={saveIcon}
                            title={saveTitle}
                            sx={{ mr: 1 }}
                        />
                    )}
                    <ButtonGeneral
                        onClick={onClickBack}
                        startIcon={<ArrowBackIcon />}
                        title="Volver"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default FormView;
